import styled, { keyframes } from 'styled-components';
import { headingFont } from '@/styles/mixins';

export { EmptyState, EmptyStateIcon, EmptyStateTitle, EmptyStateDescription } from '@/styles/shared.styled';

const pulseDot = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
`;

const blinkCursor = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
`;

export const StreamingIndicator = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[2]};
  padding: ${({ theme }) => `${theme.spacing[2]} ${theme.spacing[3]}`};
  background-color: rgba(212, 168, 67, 0.08);
  border-radius: ${({ theme }) => theme.radii.full};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  color: ${({ theme }) => theme.colors.accent700};
`;

export const StreamingDot = styled.span`
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.accent};
  animation: ${pulseDot} 1s infinite;
`;

export const ResultsWrapper = styled.div``;

export const AnswerBox = styled.div`
  background: linear-gradient(135deg, ${({ theme }) => theme.colors.primary50} 0%, ${({ theme }) => theme.colors.bgSurface} 100%);
  border: 1px solid ${({ theme }) => theme.colors.primary100};
  border-radius: ${({ theme }) => theme.radii.xl};
  padding: ${({ theme }) => theme.spacing[6]};
  margin-bottom: ${({ theme }) => theme.spacing[4]};
`;

export const AnswerHeader = styled.div`
  ${headingFont}
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[2]};
  margin-bottom: ${({ theme }) => theme.spacing[3]};
  font-size: ${({ theme }) => theme.fontSizes.base};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};

  svg {
    flex-shrink: 0;
  }
`;

export const AnswerContent = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.sm};
  line-height: ${({ theme }) => theme.lineHeights.relaxed};
  color: ${({ theme }) => theme.colors.textSecondary};

  p {
    margin: 0 0 ${({ theme }) => theme.spacing[2]};
    &:last-child {
      margin-bottom: 0;
    }
  }

  ul, ol {
    margin: 0 0 ${({ theme }) => theme.spacing[2]};
    padding-left: ${({ theme }) => theme.spacing[5]};
  }

  code {
    padding: 0.0625rem ${({ theme }) => theme.spacing[1]};
    background-color: ${({ theme }) => theme.colors.bgMuted};
    border-radius: ${({ theme }) => theme.radii.sm};
    font-size: ${({ theme }) => theme.fontSizes.xs};
  }
`;

export const AnswerCursor = styled.span`
  display: inline;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  color: ${({ theme }) => theme.colors.accent};
  animation: ${blinkCursor} 0.8s step-end infinite;
`;

export const ResultsHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.spacing[4]};
  padding-bottom: ${({ theme }) => theme.spacing[3]};
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray200};
`;

export const ResultsCount = styled.span`
  font-size: ${({ theme }) => theme.fontSizes.sm};
  color: ${({ theme }) => theme.colors.textMuted};

  strong {
    color: ${({ theme }) => theme.colors.textPrimary};
  }
`;
